module.exports = __webpack_public_path__ + "img/excellentDisplay.547d7bb2.jpg";